(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyra-header"] && !Shopify.designMode) return;
  try {
    
var vyraHeader=document.querySelector('[data-vyra-header]');
if(vyraHeader){var updateVyraHeader=function(){vyraHeader.classList.toggle('is-scrolled',window.scrollY>24);};updateVyraHeader();window.addEventListener('scroll',updateVyraHeader,{passive:true});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyra-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function track(name,detail){
    var payload={event:'vyra_'+name};
    if(detail){Object.assign(payload,detail);}
    if(Array.isArray(window.dataLayer)){window.dataLayer.push(payload);}
    window.dispatchEvent(new CustomEvent('vyra:conversion',{detail:payload}));
  }

  document.querySelectorAll('[data-vyra-track]').forEach(function(el){
    el.addEventListener('click',function(){track('click',{action:el.getAttribute('data-vyra-track')});});
  });

  document.querySelectorAll('[data-vys-build]').forEach(function(card){
    var buttons=card.querySelectorAll('[data-build-view]');
    buttons.forEach(function(button){
      button.addEventListener('click',function(){
        var view=button.getAttribute('data-build-view');
        buttons.forEach(function(btn){btn.classList.toggle('is-active',btn===button);});
        card.querySelectorAll('[data-view]').forEach(function(panel){panel.classList.toggle('is-active',panel.getAttribute('data-view')===view);});
        track('portfolio_view',{view:view});
      });
    });
  });

  var finder=document.querySelector('[data-vys-finder]');
  if(finder){
    var updateFinder=function(){
      var pages=(finder.querySelector('input[name="vys-pages"]:checked')||{}).value||'1';
      var feature=(finder.querySelector('input[name="vys-feature"]:checked')||{}).value||'basic';
      var existing=(finder.querySelector('input[name="vys-existing"]:checked')||{}).value||'no';
      var pkg='start',name='Start',price='£299',copy=finder.dataset.startCopy,url=finder.dataset.startUrl;
      if(pages==='7'||feature==='advanced'){pkg='pro';name='Pro';price='£799';copy=finder.dataset.proCopy;url=finder.dataset.proUrl;}
      else if(pages==='4'||feature==='booking'||existing==='yes'){pkg='grow';name='Grow';price='£499';copy=finder.dataset.growCopy;url=finder.dataset.growUrl;}
      finder.querySelector('[data-finder-name]').textContent=name;
      finder.querySelector('[data-finder-price]').textContent=price;
      finder.querySelector('[data-finder-copy]').textContent=copy;
      finder.querySelector('[data-finder-link]').setAttribute('href',url);
      finder.querySelector('[data-finder-link]').setAttribute('data-vyra-package',pkg);
      track('package_recommendation',{package:pkg});
    };
    finder.querySelectorAll('input').forEach(function(input){input.addEventListener('change',updateFinder);});
    updateFinder();
  }

  var brief=document.getElementById('VYRAHomeBrief');
  if(brief){
    var started=false;
    brief.addEventListener('input',function(){
      if(!started){started=true;track('brief_start');}
    },{once:false});
    brief.addEventListener('submit',function(){track('brief_submit');});
  }

  var tilt=document.querySelector('[data-vys-tilt]');
  if(tilt&&window.matchMedia('(pointer:fine)').matches&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    tilt.addEventListener('pointermove',function(event){
      var rect=tilt.getBoundingClientRect();
      var x=(event.clientX-rect.left)/rect.width-.5;
      var y=(event.clientY-rect.top)/rect.height-.5;
      tilt.style.transform='rotateX('+(-y*2.5)+'deg) rotateY('+(x*3.5)+'deg)';
    });
    tilt.addEventListener('pointerleave',function(){tilt.style.transform='';});
  }
})();

  } catch(e) { console.error(e); }
})();
})();
